(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ydl-custom-options"] && !Shopify.designMode) return;
  try {
    const initializeYdlCustomOptions = (root) => {
    if (root.dataset.initialized === 'true') {
      return;
    }

    root.dataset.initialized = 'true';

    const form = root.closest('form');
    const selects = Array.from(root.querySelectorAll('select'));
    const connectorSelect = root.querySelector('[data-ydl-connector-select]');
    const ntcSelect = root.querySelector('[data-ydl-ntc-select]');
    const minimumMessage = root.querySelector('[data-ydl-custom-minimum]');
    const orderButton = form ? form.querySelector('[data-action="add-to-cart"]') : null;

    if (!form || selects.length === 0 || !minimumMessage) {
      return;
    }

    const isCustomized = () => selects.some((select) => select.value !== '');
    const hasTwentyPieceConnector = () => connectorSelect
      && connectorSelect.value !== ''
      && connectorSelect.value !== 'Molex 1.25-2P 51021-0200';
    const minimumQuantity = () => {
      if ((ntcSelect && ntcSelect.value !== '') || hasTwentyPieceConnector()) {
        return 20;
      }

      return 10;
    };
    const quantityInput = () => form.querySelector('input[name="quantity"]');
    const decreaseButton = () => form.querySelector('[data-action="decrease-picker-quantity"]');

    const syncOrderButtonText = () => {
      if (orderButton && !orderButton.disabled) {
        orderButton.textContent = isCustomized() ? 'Order Custom' : 'Order Standard';
      }
    };

    const syncDecreaseButton = () => {
      const quantity = quantityInput();
      const button = decreaseButton();

      if (!quantity || !button) {
        return;
      }

      const currentQuantity = Number.parseInt(quantity.value, 10) || 1;
      const minimum = minimumQuantity();
      button.disabled = minimum > 1 && currentQuantity <= minimum;
      button.setAttribute('aria-disabled', button.disabled ? 'true' : 'false');
    };

    const syncCustomization = () => {
      const minimum = minimumQuantity();
      const custom = minimum > 1;
      const quantity = quantityInput();

      minimumMessage.hidden = !custom;
      minimumMessage.textContent = minimum === 20
        ? minimumMessage.dataset.minimumTwenty
        : minimumMessage.dataset.minimumTen;

      if (quantity) {
        quantity.min = String(minimum);

        if (custom && (Number.parseInt(quantity.value, 10) || 0) < minimum) {
          quantity.value = String(minimum);
          quantity.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      syncDecreaseButton();
      syncOrderButtonText();
    };

    selects.forEach((select) => select.addEventListener('change', syncCustomization));

    form.addEventListener('click', (event) => {
      const decrease = event.target.closest('[data-action="decrease-picker-quantity"]');
      const quantity = quantityInput();
      const minimum = minimumQuantity();

      if (decrease && quantity && minimum > 1 && (Number.parseInt(quantity.value, 10) || 0) <= minimum) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }

      window.requestAnimationFrame(syncDecreaseButton);
    }, true);

    form.addEventListener('change', (event) => {
      const minimum = minimumQuantity();

      if (event.target.matches('input[name="quantity"]') && minimum > 1) {
        const enteredQuantity = Number.parseInt(event.target.value, 10) || 0;

        if (enteredQuantity < minimum) {
          event.target.value = String(minimum);
        }

        syncDecreaseButton();
      }
    });

    form.addEventListener('submit', (event) => {
      const quantity = quantityInput();
      const minimum = minimumQuantity();

      if (quantity && minimum > 1 && (Number.parseInt(quantity.value, 10) || 0) < minimum) {
        event.preventDefault();
        event.stopImmediatePropagation();
        quantity.value = String(minimum);
        quantity.focus();
        minimumMessage.hidden = false;
      }
    }, true);

    syncCustomization();
  };

  document.querySelectorAll('[data-ydl-custom-options]').forEach(initializeYdlCustomOptions);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-ydl-custom-options]').forEach(initializeYdlCustomOptions);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ydl-volume-pricing"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (root) => {
      if (root.dataset.ydlVolumePricingReady === 'true') return;

      const data = root.querySelector('[data-ydl-variant-prices]');
      const form = root.closest('form[action*="/cart/add"]') || root.closest('.product-form');
      if (!data || !form) return;

      let prices;
      try {
        prices = JSON.parse(data.textContent);
      } catch {
        return;
      }

      const update = () => {
        const variantInput = form.querySelector('[name="id"]');
        const cents = prices[String(variantInput?.value)];
        if (!Number.isFinite(cents)) return;

        const currency = root.dataset.currency;
        const locale = root.dataset.locale || document.documentElement.lang || 'en';
        const formatter = new Intl.NumberFormat(locale, {
          style: 'currency',
          currency
        });

        root.querySelectorAll('[data-ydl-tier-price]').forEach((price) => {
          const discount = Number(price.dataset.discount);
          const discountedCents = cents - Math.floor(cents * discount / 100);
          price.textContent = `${formatter.format(discountedCents / 100)} ${currency}`;
        });
      };

      form.addEventListener('change', update);
      update();
      root.dataset.ydlVolumePricingReady = 'true';
    };

    const initializeAll = () => {
      document.querySelectorAll('[data-ydl-volume-pricing]').forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    } else {
      initializeAll();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
